// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"bcb7180c","435":"bcb7180c","9680":"bcb7180c"}[chunkId] + ".chunk.css";
};